var _style, _rect, _rect2, _circle, _circle2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleSwitchedFloorSockets01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7.5,
    className: "st0",
    width: 4.9,
    height: 4.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 7.5,
    className: "st0",
    width: 4.9,
    height: 4.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.5,
    cy: 10,
    r: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10.5,
    cy: 10,
    r: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 5.5,
    y1: 9.1,
    x2: 5.5,
    y2: 3.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 10.5,
    y1: 9.1,
    x2: 10.5,
    y2: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleSwitchedFloorSockets01);
export default __webpack_public_path__ + "static/media/DoubleSwitchedFloorSockets-01.e1174e31162e8c2096141a51d66ceb8f.svg";
export { ForwardRef as ReactComponent };